/** The admin's input look (as on the coordination workspace), shared by every
 * Transport settings control. `min-w-0` lets a control shrink at 390px. */
export const INPUT =
  'h-9 min-w-0 rounded-[8px] border border-line-2 bg-bg-app px-2 text-sm text-ink-1 placeholder:text-ink-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent'

export const LABEL =
  'flex min-w-0 flex-col gap-1 text-xs font-medium text-ink-2'

export const ZONE_NAMES: Record<number, string> = {
  0: 'Outside Greater Accra (quoted by phone)',
  1: 'Zone 1',
  2: 'Zone 2',
  3: 'Zone 3',
}
